import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo-probus.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "reset-password" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "reset-password--logo-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "reset-password--title" }, "Reset your password", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "reset-password--text" }, " Enter your new password, make sure to make strong password include numbers, letters, and punctuation marks ", -1)
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = ["disabled"]

import { ref } from 'vue'
import { ResetPasswordForm } from '@/models/login'
import { useResetPassword } from '@/store/user'
import { useRouter, useRoute } from 'vue-router'
import { toastError } from '@/store/toasts'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

const form = ref(new ResetPasswordForm())
const { resetPassword, error, errors, isPending } = useResetPassword()
const route = useRoute()
const router = useRouter()

toastError(error)

const onSubmit = async () => {
  await resetPassword(route.params.code as string, form.value)
  router.push({ name: 'login' })
}

return (_ctx: any,_cache: any) => {
  const _component_FormControl = _resolveComponent("FormControl")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("form", {
        onSubmit: _withModifiers(onSubmit, ["prevent"]),
        class: "reset-password--form"
      }, [
        _createVNode(_component_FormControl, {
          type: "password",
          modelValue: form.value.password,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.password) = $event)),
          placeholder: "new password",
          error: _unref(errors).password
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_FormControl, {
          type: "password",
          modelValue: form.value.confirmPassword,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.confirmPassword) = $event)),
          placeholder: "confirm your new password"
        }, null, 8, ["modelValue"]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-block",
          disabled: _unref(isPending)
        }, "Reset", 8, _hoisted_7)
      ], 40, _hoisted_6)
    ])
  ]))
}
}

})